import { postUpdateBalance } from '../api/postUpdateBalance';
import {setGetUserById} from './setGetUserById';

const setPostUpdateBalance = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateBalance(params);
            dispatch(setGetUserById(params.id));
            window.location.replace(window.location.pathname);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateBalance
}